import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnscreenNotificationComponent } from './onscreen-notification.component';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [OnscreenNotificationComponent],
  imports: [CommonModule, MatIconModule, RouterModule],
  exports: [OnscreenNotificationComponent],
})
export class OnscreenNotificationModule {}
